import { AuthFlowCard } from '@/features/register/AuthFlowCard';
import { createFileRoute } from '@tanstack/react-router';

function LoginMagicPage() {
  return <AuthFlowCard useCase="login" useNext />;
}

export const Route = createFileRoute('/_auth/login-magic')({
  component: LoginMagicPage,
});
